import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  StyledModalHeader,
  StyledLabel,
  PicturePicker,
} from '../../../../../common/form/FormElements.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import UploadForm from '../../../../../common/modals/FileUploadModal/UploadForm.jsx';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import {
  useGetPresentationImagesQuery,
  useUploadFileMutation,
} from '../../../../../../redux/services/filesApi.jsx';
import { isUndefined } from 'lodash';
import { imageTypes } from '../../../../../../hooks/useFileDraggerFileValidation.jsx';

const PictureChoosing = ({ isOpen, onClose, form }) => {
  const { t } = useTranslation();

  const {
    data: imageUrls,
    isLoading,
    refetch,
  } = useGetPresentationImagesQuery();
  const [uploadFile] = useUploadFileMutation();

  const imageName = Form.useWatch('image_name', form);

  return isLoading ? (
    <Spinner />
  ) : (
    <StyledModal
      open={isOpen}
      width="100%"
      style={{ maxWidth: '1600px' }}
      onCancel={() => onClose()}
      footer={null}
      afterOpenChange={() => refetch()}
    >
      <StyledModalHeader>{t('Výber prezentačného obrázka')}</StyledModalHeader>
      <div style={{ padding: '10px' }} className="picture-choosing-modal-body">
        <UploadForm
          allowedTypes={imageTypes}
          onClose={() => onClose()}
          uploadOnDrop
          onFileUpload={({ file }, clearFileList) => {
            uploadFile({
              file: file,
              directory: 'presentation_images',
              thumbnail: true,
            })
              .unwrap()
              .then(({ relative_path }) => {
                if (isUndefined(relative_path)) {
                  return;
                }

                refetch();
                form.setFieldValue('image_name', relative_path);
                onClose();

                clearFileList();
              });
          }}
        />

        {(imageUrls || []).length > 0 ? (
          <>
            <StyledLabel>
              {t('V minulosti použité prezentačné obrázky')}
            </StyledLabel>

            <div className="img-picker-comp-container">
              {imageUrls.map(({ relative_path }) => (
                <PicturePicker
                  key={relative_path}
                  url={relative_path}
                  active={relative_path === imageName}
                  onClick={() => {
                    form.setFieldValue('image_name', relative_path);
                    onClose();
                  }}
                />
              ))}
            </div>
          </>
        ) : null}
      </div>
    </StyledModal>
  );
};

PictureChoosing.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

export default PictureChoosing;
